import React, { useState } from "react";
import "../../styles/Search.css"; 

const Search = ({ searchFields, onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <div>
      <input
        type="text"
        placeholder={`Type here...`}
        className="w-full border-none pr-4 border border-gray-300 rounded-md focus:outline-none"
        value={searchTerm}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default Search;
